module.exports = __webpack_public_path__ + "img/album15_02.1c6d656d.jpg";